import { Map } from "immutable"

import {
    INSIGHT_AREA_ADD_MAPPING as ADD_MAPPING,
    INSIGHT_AREA_ADD_NEW as ADD_NEW,
    INSIGHT_AREA_ADD_PLACEHOLDER_IMAGES as ADD_PLACEHOLDER_IMAGES,
    INSIGHT_AREA_APPLY_ADD_OWNERS_VIEWERS as APPLY_ADD_OWNERS_VIEWERS,
    INSIGHT_AREA_APPLY_FILTER_CRITERIA as APPLY_FILTER_CRITERIA,
    INSIGHT_AREA_APPLY_MODEL_UPDATE as APPLY_MODEL_UPDATE,
    ATTACHMENT_ITEM_DELETE_RESPONSE,
    ATTACHMENT_ITEM_SAVE_RESPONSE,
    ATTACHMENT_LIST_CACHED_RESPONSE,
    ATTACHMENT_LIST_RESPONSE,
    ATTACHMENT_UPDATE_ADD_MODEL,
    ATTACHMENT_UPDATE_DELETE_MODEL,
    ATTACHMENT_UPDATE_REMOVE_MODEL,
    INSIGHT_AREA_CANCEL_ADD_OWNERS_VIEWERS as CANCEL_ADD_OWNERS_VIEWERS,
    INSIGHT_AREA_CANCEL_MODEL_UPDATE as CANCEL_MODEL_UPDATE,
    INSIGHT_AREA_CLEAR_FILTER_CRITERIA as CLEAR_FILTER_CRITERIA,
    INSIGHT_AREA_FINISH_SAVING,
    INSIGHT_AREA_FINISH_SAVING_ERROR,
    INSIGHT_AREA_ITEM_REQUEST as ITEM_REQUEST,
    INSIGHT_AREA_ITEM_RESPONSE as ITEM_RESPONSE,
    INSIGHT_AREA_ITEM_SAVE_RESPONSE as ITEM_SAVE_RESPONSE,
    INSIGHT_AREA_LIST_PAGE_REQUEST as LIST_PAGE_REQUEST,
    INSIGHT_AREA_LIST_RESPONSE as LIST_RESPONSE,
    INSIGHT_AREA_LIST_SEARCH_REQUEST as LIST_SEARCH_REQUEST,
    INSIGHT_AREA_MAPPING_DELETE_PREVIEW_REQUEST as MAPPING_DELETE_PREVIEW_REQUEST,
    INSIGHT_AREA_MAPPING_PREVIEW_ERROR_RESPONSE as MAPPING_PREVIEW_ERROR_RESPONSE,
    INSIGHT_AREA_MAPPING_PREVIEW_REQUEST as MAPPING_PREVIEW_REQUEST,
    INSIGHT_AREA_MAPPING_PREVIEW_RESPONSE as MAPPING_PREVIEW_RESPONSE,
    INSIGHT_AREA_REMOVE_MAPPING as REMOVE_MAPPING,
    INSIGHT_AREA_REMOVE_OWNER_VIEWER as REMOVE_OWNER_VIEWER,
    INSIGHT_AREA_REMOVE_PLACEHOLDER as REMOVE_PLACEHOLDER,
    INSIGHT_AREA_SEARCH_ADD_OWNERS_VIEWERS as SEARCH_ADD_OWNERS_VIEWERS,
    INSIGHT_AREA_SEARCH_ADD_OWNERS_VIEWERS_RESPONSE as SEARCH_ADD_OWNERS_VIEWERS_RESPONSE,
    INSIGHT_AREA_SELECT_ADD_OWNER_VIEWER as SELECT_ADD_OWNER_VIEWER,
    INSIGHT_AREA_SELECT_PERMISSION_HOLDER_TYPE as SELECT_PERMISSION_HOLDER_TYPE,
    INSIGHT_AREA_SET_EDIT_MODE as SET_EDIT_MODE,
    INSIGHT_AREA_SET_FILTER as SET_FILTER,
    INSIGHT_AREA_UPDATE_FILTER_CRITERIA as UPDATE_FILTER_CRITERIA,
    INSIGHT_AREA_UPDATE_IMAGE as UPDATE_IMAGE,
    INSIGHT_AREA_UPDATE_MODEL as UPDATE_MODEL,
    INSIGHT_AREA_UPDATE_PLACEHOLDER_ATTRIBUTION as UPDATE_PLACEHOLDER_ATTRIBUTION,
    INSIGHT_AREA_FINGERPRINT_PREVIEW_REQUEST as FINGERPRINT_PREVIEW_REQUEST,
    INSIGHT_AREA_FINGERPRINT_PREVIEW_RESPONSE as FINGERPRINT_PREVIEW_RESPONSE,
    INSIGHT_AREA_FINGERPRINT_PREVIEW_ERROR_RESPONSE as FINGERPRINT_PREVIEW_ERROR_RESPONSE,
    INSIGHT_AREA_FINGERPRINT_REMOVE_CONCEPT as FINGERPRINT_REMOVE_ITEM,
} from "../../../actions/action-types"
import {
    InsightAreaFilterModel,
    updateInsightAreaSearchFilterModel,
} from "../../../models/filters/insight-area-filter"
import { composeReducers } from "../presentation-reducer-utils"
import {
    idify,
    serialiseSearchCriteria,
} from "../../paging/paging-reducer-utils"
import {
    updateTopicChangeModel,
    updateTopicCreateModel,
    TopicModel,
    TopicCreateModel,
} from "../../../models/entities/topic"
import PresentationReducerBuilder from "../build-presentation-reducer"
import buildMappingsPresentationReducer from "./mappings-reducer"
import buildOwnerViewerPresentationReducer from "../build-owner-viewer-presentation-reducer"
import buildPlaceholdersPresentationReducer from "../build-placeholders-presentation-reducer"
import { defaultSearchCriteria } from "../../paging/topic-paging-reducer"
import buildFingerprintEditorPresentationReducer from "./build-fingerprint-editor-presentation-reducer"

const reducerBuilder = new PresentationReducerBuilder()
const defaultReducer = reducerBuilder
    .actionsToHandle({
        UPDATE_IMAGE,
        UPDATE_MODEL,
        APPLY_MODEL_UPDATE,
        CANCEL_MODEL_UPDATE,
        CLEAR_FILTER_CRITERIA,
        UPDATE_FILTER_CRITERIA,
        APPLY_FILTER_CRITERIA,
        SET_FILTER,
        SET_EDIT_MODE,
        ITEM_REQUEST,
        ITEM_RESPONSE,
        LIST_PAGE_REQUEST,
        LIST_SEARCH_REQUEST,
        LIST_RESPONSE,
        ADD_NEW,
    })
    .updateChangeModel(updateTopicChangeModel)
    .updateCreateModel(updateTopicCreateModel)
    .updateSearchFilterModel(updateInsightAreaSearchFilterModel)
    .workingFilterModelClass(InsightAreaFilterModel)
    .workingModelClass(TopicModel)
    .canCancel(() => true)
    .createModelClass(TopicCreateModel)
    .defaultState({
        workingModel: new TopicModel(),
        searchCriteria: serialiseSearchCriteria(defaultSearchCriteria),
        workingFilterModel: new InsightAreaFilterModel(),
        searchFilterModel: defaultSearchCriteria,
        selectedPermissionHolder: "viewers",
        isFetchingPreview: false,
        isFetchingOwnersViewersSearch: false,
        isAddingOwnersViewers: false,
        ownersToAdd: [],
        viewersToAdd: [],
        media: [],
        mediaToAdd: [],
        mediaToDelete: [],
        mediaToView: [],
        ownersViewersSearchResponse: [],
        mappingPreview: null,
        fingerprintPreview: null,
    })
    .build()
const mappingsReducer = buildMappingsPresentationReducer(
    {
        ADD_MAPPING,
        REMOVE_MAPPING,
        MAPPING_PREVIEW_REQUEST,
        MAPPING_DELETE_PREVIEW_REQUEST,
        MAPPING_PREVIEW_RESPONSE,
        MAPPING_PREVIEW_ERROR_RESPONSE,
    },
    updateTopicChangeModel,
    updateTopicCreateModel,
    reducerBuilder._canSave
)
const fingerprintEditorReducer = buildFingerprintEditorPresentationReducer(
    {
        FINGERPRINT_PREVIEW_REQUEST,
        FINGERPRINT_PREVIEW_RESPONSE,
        FINGERPRINT_PREVIEW_ERROR_RESPONSE,
        FINGERPRINT_REMOVE_ITEM,
    },
    updateTopicChangeModel,
    updateTopicCreateModel
)
const placeholderReducer = buildPlaceholdersPresentationReducer(
    {
        ADD_PLACEHOLDER_IMAGES,
        UPDATE_PLACEHOLDER_ATTRIBUTION,
        REMOVE_PLACEHOLDER,
    },
    reducerBuilder._canSave
)
const ownerViewerReducer = buildOwnerViewerPresentationReducer(
    {
        SELECT_PERMISSION_HOLDER_TYPE,
        SEARCH_ADD_OWNERS_VIEWERS,
        SEARCH_ADD_OWNERS_VIEWERS_RESPONSE,
        SELECT_ADD_OWNER_VIEWER,
        APPLY_ADD_OWNERS_VIEWERS,
        CANCEL_ADD_OWNERS_VIEWERS,
        REMOVE_OWNER_VIEWER,
    },
    updateTopicChangeModel,
    updateTopicCreateModel,
    reducerBuilder._canSave
)

export default (state = undefined, action) => {
    const defaultReduction = composeReducers(
        state,
        action,
        defaultReducer,
        placeholderReducer,
        mappingsReducer,
        fingerprintEditorReducer,
        ownerViewerReducer
    )
    const { type, name, value, attachment } = action
    let { media, mediaToView, mediaToAdd, mediaToDelete } = defaultReduction

    let stateReset = {
        mappingToBeAdded: {
            positive: [],
        },
        fingerprintRemovedConcepts: [],
        fingerprintPreview: null,
        isFetchingFingerprintPreview: false,
        mappingToBeDeleted: null,
        mappingPreview: null,
        isAddingOwnersViewers: false,
        ownersToAdd: [],
        viewersToAdd: [],
        mediaToAdd: [],
        mediaToDelete: [],
        ownersViewersSearchResponse: [],
    }

    switch (type) {
        case ITEM_RESPONSE:
        case SET_EDIT_MODE:
            return {
                ...defaultReduction,
                ...stateReset,
            }
        case ITEM_SAVE_RESPONSE:
            const { error, data } = action
            return {
                ...defaultReduction,
                activeId: data.id,
                workingModel: TopicModel(data),
                updateModel: new Map(),
                imageToUpload: undefined,
                error: error ? "Error Message" : null,
                mediaToAdd: mediaToAdd.map((medium) => {
                    // when creating a new insight area, id's need to be added to the media
                    if (!medium.fields.topic_id) {
                        medium.fields.topic_id = data.id
                    }
                    return medium
                }),
            }
        case ADD_NEW:
            return {
                ...defaultReduction,
                ...stateReset,
                media: [],
                mediaToView: [],
            }
        case INSIGHT_AREA_FINISH_SAVING:
            return {
                ...defaultReduction,
                canSave: false,
                canCancel: true,
                isEditMode: false,
                isCreateMode: false,
                isSavingItem: false,
                ...stateReset,
            }
        case INSIGHT_AREA_FINISH_SAVING_ERROR:
            return {
                ...defaultReduction,
                isSavingItem: false,
                canSave: true,
                canCancel: true,
            }
        case UPDATE_FILTER_CRITERIA:
        case LIST_SEARCH_REQUEST:
            let { searchFilterModel } = defaultReduction
            if (name === "empty" && value === false)
                searchFilterModel = searchFilterModel.remove("empty")
            return {
                ...defaultReduction,
                searchFilterModel,
            }
        case ATTACHMENT_LIST_RESPONSE:
            const idData = idify(action.data)
            return {
                ...defaultReduction,
                media: idData,
                mediaToView: idData,
            }
        case ATTACHMENT_LIST_CACHED_RESPONSE:
            return {
                ...defaultReduction,
                media: action.data,
                mediaToView: action.data,
            }
        case ATTACHMENT_UPDATE_REMOVE_MODEL:
            mediaToAdd = mediaToAdd.filter((medium) => medium !== attachment)

            return {
                ...defaultReduction,
                canSave:
                    reducerBuilder._canSave(
                        defaultReduction.updateModel,
                        defaultReduction.imageToUpload,
                        defaultReduction.workingModel
                    ) ||
                    (mediaToAdd.length > 0 && mediaToDelete.length > 0),
                mediaToAdd,
            }
        case ATTACHMENT_UPDATE_DELETE_MODEL:
            mediaToDelete = [
                ...mediaToDelete,
                ...mediaToView.filter((medium) => medium === attachment.id),
            ]

            return {
                ...defaultReduction,
                canSave: true,
                mediaToAdd: mediaToAdd.filter(
                    (medium) => medium !== attachment
                ),
                mediaToView: mediaToView.filter(
                    (medium) => medium !== attachment.id
                ),
                mediaToDelete,
            }
        case ATTACHMENT_UPDATE_ADD_MODEL:
            mediaToAdd = [...mediaToAdd, attachment]

            return {
                ...defaultReduction,
                canSave: true,
                mediaToAdd,
            }
        case ATTACHMENT_ITEM_DELETE_RESPONSE:
            media = media.filter((medium) => medium !== action.id)

            return {
                ...defaultReduction,
                media,
                mediaToView: media,
            }
        case ATTACHMENT_ITEM_SAVE_RESPONSE:
            media = [action.data.attachment_id, ...media]

            return {
                ...defaultReduction,
                media,
                mediaToView: media,
            }
        default:
            return defaultReduction
    }
}
